/**
 * Copyright (C) 2023 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import { ManualDowntimePeriodRequest } from '../../shared/entities/manualDowntimePeriod';
import ActionCreator from '../action-creator';

export const ActionCreators = {
  RequestManualDowntimePeriods: new ActionCreator<'RequestManualDowntimePeriods', string>(
    'RequestManualDowntimePeriods',
  ),
  ReceivedManualDowntimePeriodsSuccess: new ActionCreator<'ReceivedManualDowntimePeriodsSuccess', any>(
    'ReceivedManualDowntimePeriodsSuccess',
  ),
  ReceivedManualDowntimePeriodsError: new ActionCreator<'ReceivedManualDowntimePeriodsError', any>(
    'ReceivedManualDowntimePeriodsError',
  ),

  ClearManualDowntimePeriods: new ActionCreator<'ClearManualDowntimePeriods', any>('ClearManualDowntimePeriods'),

  AddManualDowntimePeriod: new ActionCreator<'AddManualDowntimePeriod', ManualDowntimePeriodRequest>(
    'AddManualDowntimePeriod',
  ),
  AddedManualDowntimePeriodSuccess: new ActionCreator<'AddedManualDowntimePeriodSuccess', any>(
    'AddedManualDowntimePeriodSuccess',
  ),
  AddedManualDowntimePeriodError: new ActionCreator<'AddedManualDowntimePeriodError', any>(
    'AddedManualDowntimePeriodError',
  ),

  DeleteManualDowntimePeriod: new ActionCreator<'DeleteManualDowntimePeriod', string>('DeleteManualDowntimePeriod'),
  DeletedManualDowntimePeriodSuccess: new ActionCreator<'DeletedManualDowntimePeriodSuccess', any>(
    'DeletedManualDowntimePeriodSuccess',
  ),
  DeletedManualDowntimePeriodError: new ActionCreator<'DeletedManualDowntimePeriodError', any>(
    'DeletedManualDowntimePeriodError',
  ),
  RemoveManualDowntimePeriodFromStoreById: new ActionCreator<'RemoveManualDowntimePeriodFromStoreById', string>(
    'RemoveManualDowntimePeriodFromStoreById',
  ),
};

export type Action = typeof ActionCreators[keyof typeof ActionCreators];

export function requestManualDowntimePeriods(tailNumber: string) {
  return ActionCreators.RequestManualDowntimePeriods.create(tailNumber);
}

export function clearManualDowntimePeriods() {
  return ActionCreators.ClearManualDowntimePeriods.create();
}
export function addManualDowntimePeriod(manualDowntimePeriodRequest: ManualDowntimePeriodRequest) {
  return ActionCreators.AddManualDowntimePeriod.create(manualDowntimePeriodRequest);
}

export function deleteManualDowntimePeriod(id: string) {
  return ActionCreators.DeleteManualDowntimePeriod.create(id);
}
export function removeManualDowntimePeriodFromStoreById(id: string) {
  return ActionCreators.RemoveManualDowntimePeriodFromStoreById.create(id);
}
